import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Col, Form, Row } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const AddImage = () => {
  const history = useHistory();
  const { id } = useParams();

  const [images, setImages] = useState([null, null, null, null]);
  const [previews, setPreviews] = useState([null, null, null, null]);

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      // Update images array
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        const newPreviews = [...previews];
        newPreviews[index] = reader.result;
        setPreviews(newPreviews);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (index) => {
    const newImages = [...images];
    const newPreviews = [...previews];
    newImages[index] = null;
    newPreviews[index] = null;
    setImages(newImages);
    setPreviews(newPreviews);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Example: first image is the main profile image(s)
    const profileImages = images.filter((img, idx) => idx === 0 && img); // or pick multiple as profile
    profileImages.forEach((file) => {
      formData.append("profilePic", file); // multiple files under same key
    });

    // The rest of the images (indices 1,2,3) as separate keys
    const individualImages = {};
    images.forEach((file, index) => {
      if (index !== 0 && file) {
        individualImages[`image${index}`] = file; // e.g., image1, image2
      }
    });

    Object.entries(individualImages).forEach(([key, file]) => {
      formData.append(key, file);
    });

    const url = `admin/userProfile/images?userId=${id}`;

    api
      .post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.data || "Images uploaded successfully",
        });
        history.push(`/adddoc/${id}`);
      })
      .catch((err) => {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error uploading images",
        });
      });
  };

  return (
    <div className="content">
      <Row>
        <Col xs={12}>
          <div className="page-title mb-4 ">
            <h1 className="title">Add Images</h1>
          </div>
          <div className="col-12">
            <section className="box">
              <div className="content-body p-4">
                <Form onSubmit={handleSubmit}>
                  <label className="form-label" htmlFor="profile-images">
                    <h5>Profile Images </h5>
                  </label>
                  <div
                    className="d-flex flex-wrap gap-3"
                    style={{ justifyContent: "flex-start" }}
                  >
                    {[0, 1, 2, 3].map((index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          width: "150px",
                          height: "150px",
                          border: "2px dashed #ddd",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                        }}
                      >
                        {previews[index] ? (
                          <>
                            <img
                              src={previews[index]}
                              alt={`Preview ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => removeImage(index)}
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                background: "rgba(0,0,0,0.7)",
                                border: "none",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                color: "white",
                                fontSize: "12px",
                              }}
                            >
                              &times;
                            </button>
                          </>
                        ) : (
                          <label
                            htmlFor={`image-${index}`}
                            style={{
                              cursor: "pointer",
                              textAlign: "center",
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              fontSize: "12px",
                            }}
                          >
                            <i className="fa fa-upload" style={{ fontSize: "24px", color: "#6c757d" }}></i>
                            <div>Image {index + 1}</div>
                            <input
                              type="file"
                              id={`image-${index}`}
                              accept=".jpg, .jpeg, .png"
                              style={{ display: "none" }}
                              onChange={(e) => handleImageChange(e, index)}
                            />
                          </label>
                        )}
                      </div>
                    ))}
                  </div>


                  <div className="mt-4">
                    <Button
                      style={{
                        background: "#000",
                        border: "none",
                        padding: "10px 30px",
                      }}
                      type="submit"
                    >
                      <i className="fa fa-check mr-2"></i>
                      Submit
                    </Button>
                  </div>
                </Form>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AddImage;